import {OnInit, Component, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule, Router} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import { PRODUCT_TS } from '../../MainComponent';

@Component({
    selector: 'home',
    templateUrl: "../../../../views/components/app/home/home.html",
    providers: []
})
export class Home implements OnInit {
    PRODUCT: any;
    constructor(private router: Router) {
        this.PRODUCT = PRODUCT_TS;
    }

    ngOnInit(){
    }
}

@NgModule({
    declarations: [Home],
    imports: [FormsModule, BrowserModule, RouterModule],
    providers: [],
    entryComponents: [],
    exports: [Home]
})
export class HomeModule{
}